/* FRANK14 · bold — le foto del capo a schermo intero.
   1. clic/tocco su una foto della scheda → si apre sul nero, su QUELLA foto;
   2. avanti/indietro: frecce, tasti ← →, scorrimento col dito;
   3. zoom: doppio clic / doppio tocco o due dita, poi si trascina;
      la foto grande si chiede al CDN a 1200/1800/2400 px;
   4. chiudi, Esc, focus intrappolato dentro e restituito alla foto;
   5. sul telefono, frecce anche sulla striscia della scheda.
   Le foto si rileggono dalla pagina a ogni apertura (se cambia la variante,
   valgono quelle di adesso). Mentre è aperto, la pagina sotto non scorre
   (Lenis fermo) e alla chiusura si ricalcola. Niente librerie. */
(function () {
  'use strict';
  var scheda = document.querySelector('product-info.pr');
  if (!scheda) return;
  var pigro = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ZOOM = 2.5, ZOOM_MAX = 4;

  function tutti(sel, radice) { return Array.prototype.slice.call((radice || document).querySelectorAll(sel)); }
  function due(n) { return (n < 10 ? '0' : '') + n; }
  function figure() { return tutti('[data-pr-figura]', scheda).filter(function (f) { return f.querySelector('img'); }); }
  function conLarghezza(url, w) {
    if (!url) return '';
    return /[?&]width=\d+/.test(url) ? url.replace(/([?&])width=\d+/, '$1width=' + w) : url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  var ICONA = {
    chiudi: '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M4 4l12 12M16 4 4 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    prima: '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M12.5 4 6.5 10l6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    dopo: '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M7.5 4l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  /* ---------- il lightbox, costruito una volta, fuori da <main> ---------- */
  var lb = document.createElement('div');
  lb.className = 'pr-lb';
  lb.setAttribute('role', 'dialog');
  lb.setAttribute('aria-modal', 'true');
  lb.setAttribute('aria-label', 'Le foto del capo a schermo intero');
  lb.setAttribute('aria-hidden', 'true');
  lb.innerHTML =
    '<div class="pr-lb__testa">' +
      '<p class="pr-lb__conta" aria-live="polite"><span data-lb-n>01</span><i>/</i><b data-lb-tot>01</b></p>' +
      '<button type="button" class="pr-lb__bottone" data-lb-chiudi aria-label="Chiudi le foto">' + ICONA.chiudi + '</button>' +
    '</div>' +
    '<div class="pr-lb__scena" data-lb-scena>' +
      '<img class="pr-lb__img" data-lb-img alt="" draggable="false">' +
      '<div class="pr-lb__frecce">' +
        '<button type="button" class="pr-lb__bottone" data-lb-prima aria-label="Foto precedente">' + ICONA.prima + '</button>' +
        '<button type="button" class="pr-lb__bottone" data-lb-dopo aria-label="Foto successiva">' + ICONA.dopo + '</button>' +
      '</div>' +
    '</div>' +
    '<p class="pr-lb__piede"><span class="pr-lb__mouse">Doppio clic per ingrandire · ← → per scorrere · Esc per chiudere</span><span class="pr-lb__mano">Doppio tocco o due dita per ingrandire · scorri per cambiare foto</span></p>';
  document.body.appendChild(lb);

  var scena = lb.querySelector('[data-lb-scena]');
  var img = lb.querySelector('[data-lb-img]');
  var nodoN = lb.querySelector('[data-lb-n]');
  var nodoTot = lb.querySelector('[data-lb-tot]');
  var bChiudi = lb.querySelector('[data-lb-chiudi]');
  var bPrima = lb.querySelector('[data-lb-prima]');
  var bDopo = lb.querySelector('[data-lb-dopo]');

  var lista = [], indice = 0, aperto = false, daDove = null;
  var z = { s: 1, x: 0, y: 0 };

  function applica() {
    img.style.transform = 'translate3d(' + z.x.toFixed(1) + 'px,' + z.y.toFixed(1) + 'px,0) scale(' + z.s.toFixed(3) + ')';
    lb.classList.toggle('is-zoom', z.s > 1.01);
  }
  /* la foto ingrandita copre la scena e non si stacca dai bordi */
  function limita() {
    var sr = scena.getBoundingClientRect();
    var L = img.offsetLeft, T = img.offsetTop, W = img.offsetWidth, H = img.offsetHeight;
    var sw = W * z.s, sh = H * z.s;
    if (sw <= sr.width) z.x = (sr.width - sw) / 2 - L; else z.x = Math.min(-L, Math.max(sr.width - L - sw, z.x));
    if (sh <= sr.height) z.y = (sr.height - sh) / 2 - T; else z.y = Math.min(-T, Math.max(sr.height - T - sh, z.y));
  }
  function azzera() { z.s = 1; z.x = 0; z.y = 0; applica(); }
  /* ingrandisce tenendo fermo il punto (px, py) della scena */
  function ingrandisci(s2, px, py) {
    s2 = Math.min(ZOOM_MAX, Math.max(1, s2));
    var L = img.offsetLeft, T = img.offsetTop;
    var ux = (px - L - z.x) / z.s, uy = (py - T - z.y) / z.s;
    z.x = px - L - s2 * ux; z.y = py - T - s2 * uy; z.s = s2;
    if (z.s <= 1.01) { azzera(); return; }
    limita(); applica();
  }
  function puntoScena(e) { var r = scena.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }

  function mostra(i) {
    if (!lista.length) return;
    indice = (i + lista.length) % lista.length;
    var sorgente = lista[indice];
    var url = sorgente.currentSrc || sorgente.src;
    azzera();
    if (!pigro) img.classList.add('is-cambio');
    var nuova = new Image();
    nuova.onload = nuova.onerror = function () {
      img.srcset = [1200, 1800, 2400].map(function (w) { return conLarghezza(url, w) + ' ' + w + 'w'; }).join(', ');
      img.sizes = '100vw';
      img.src = conLarghezza(url, 1800);
      img.alt = sorgente.alt || '';
      img.classList.remove('is-cambio');
    };
    nuova.src = conLarghezza(url, window.innerWidth > 1200 ? 2400 : 1800);
    nodoN.textContent = due(indice + 1);
    nodoTot.textContent = due(lista.length);
    var una = lista.length < 2;
    bPrima.hidden = una; bDopo.hidden = una;
    /* la vicina dopo, già pronta */
    if (!una) { var v = lista[(indice + 1) % lista.length]; (new Image()).src = conLarghezza(v.currentSrc || v.src, 1800); }
  }

  function apri(i, da) {
    lista = figure().map(function (f) { return f.querySelector('img'); });
    if (!lista.length) return;
    daDove = da || null;
    aperto = true;
    tutti('.con-lente', scheda).forEach(function (f) { f.classList.remove('con-lente'); });
    lb.setAttribute('aria-hidden', 'false');
    lb.classList.add('is-aperto');
    document.documentElement.classList.add('pr-lb-aperto');
    if (window.__lenis && window.__lenis.stop) window.__lenis.stop();
    mostra(i);
    bChiudi.focus({ preventScroll: true });
  }
  function chiudi() {
    if (!aperto) return;
    aperto = false;
    lb.classList.remove('is-aperto');
    lb.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('pr-lb-aperto');
    azzera();
    if (window.__lenis) {
      if (window.__lenis.start) window.__lenis.start();
      if (window.__lenis.resize) window.__lenis.resize();
    }
    if (window.ScrollTrigger) window.ScrollTrigger.refresh();
    if (daDove) daDove.focus({ preventScroll: true });
  }

  bChiudi.addEventListener('click', chiudi);
  bPrima.addEventListener('click', function () { mostra(indice - 1); });
  bDopo.addEventListener('click', function () { mostra(indice + 1); });
  document.addEventListener('keydown', function (e) {
    if (!aperto) return;
    if (e.key === 'Escape') { e.preventDefault(); chiudi(); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); mostra(indice + 1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); mostra(indice - 1); }
    else if (e.key === 'Tab') {
      /* il focus resta dentro: chiudi, precedente, successiva */
      var giri = [bChiudi, bPrima, bDopo].filter(function (b) { return !b.hidden; });
      var at = giri.indexOf(document.activeElement);
      e.preventDefault();
      var dopo = e.shiftKey ? (at <= 0 ? giri.length - 1 : at - 1) : (at === -1 || at === giri.length - 1 ? 0 : at + 1);
      giri[dopo].focus();
    }
  });

  /* ---------- zoom, trascinamento, scorrimento ---------- */
  var dita = {}, inizio = null, pizzico = null, ultimoTocco = { t: 0, x: 0, y: 0 };
  function quante() { return Object.keys(dita).length; }
  scena.addEventListener('pointerdown', function (e) {
    if (e.target.closest('button')) return;
    try { scena.setPointerCapture(e.pointerId); } catch (err) { /* puntatore già sparito: si va avanti lo stesso */ }
    dita[e.pointerId] = puntoScena(e);
    if (quante() === 1) {
      inizio = { x: dita[e.pointerId].x, y: dita[e.pointerId].y, zx: z.x, zy: z.y, t: performance.now() };
      if (z.s > 1.01) lb.classList.add('is-trascina');
    } else if (quante() === 2) {
      var p = Object.keys(dita).map(function (k) { return dita[k]; });
      pizzico = { d: Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y) || 1, s: z.s };
      lb.classList.add('is-pizzica');
    }
  });
  scena.addEventListener('pointermove', function (e) {
    if (!dita[e.pointerId]) return;
    dita[e.pointerId] = puntoScena(e);
    if (quante() === 2 && pizzico) {
      var p = Object.keys(dita).map(function (k) { return dita[k]; });
      var d = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
      ingrandisci(pizzico.s * d / pizzico.d, (p[0].x + p[1].x) / 2, (p[0].y + p[1].y) / 2);
    } else if (quante() === 1 && inizio && z.s > 1.01) {
      var q = dita[e.pointerId];
      z.x = inizio.zx + (q.x - inizio.x); z.y = inizio.zy + (q.y - inizio.y);
      limita(); applica();
    }
  });
  function lascia(e) {
    if (!dita[e.pointerId]) return;
    var q = dita[e.pointerId];
    delete dita[e.pointerId];
    lb.classList.remove('is-trascina');
    if (quante() < 2) { pizzico = null; lb.classList.remove('is-pizzica'); }
    if (quante() > 0 || !inizio) return;
    var dx = q.x - inizio.x, dy = q.y - inizio.y, ora = performance.now();
    /* a zoom 1: lo scorrimento di lato cambia foto */
    if (z.s <= 1.01 && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) {
      mostra(indice + (dx < 0 ? 1 : -1));
    } else if (e.pointerType !== 'mouse' && Math.abs(dx) < 12 && Math.abs(dy) < 12) {
      /* doppio tocco: ingrandisce lì, o torna a intera */
      if (ora - ultimoTocco.t < 320 && Math.hypot(q.x - ultimoTocco.x, q.y - ultimoTocco.y) < 30) {
        if (z.s > 1.01) azzera(); else ingrandisci(ZOOM, q.x, q.y);
        ultimoTocco.t = 0;
      } else {
        ultimoTocco = { t: ora, x: q.x, y: q.y };
      }
    }
    inizio = null;
  }
  scena.addEventListener('pointerup', lascia);
  scena.addEventListener('pointercancel', lascia);
  scena.addEventListener('dblclick', function (e) {
    if (e.target.closest('button')) return;
    var p = puntoScena(e);
    if (z.s > 1.01) azzera(); else ingrandisci(ZOOM, p.x, p.y);
  });
  window.addEventListener('resize', function () { if (aperto) { limita(); applica(); } });

  /* ---------- le foto della scheda: si aprono ---------- */
  function preparaFigure() {
    var tot = figure().length;
    figure().forEach(function (f, i) {
      if (f.hasAttribute('data-gal-apri')) return;
      f.setAttribute('data-gal-apri', '');
      f.setAttribute('tabindex', '0');
      f.setAttribute('role', 'button');
      f.setAttribute('aria-label', 'Apri la foto ' + (i + 1) + ' di ' + tot + ' a schermo intero');
    });
  }
  preparaFigure();
  scheda.addEventListener('click', function (e) {
    var f = e.target.closest('[data-gal-apri]');
    if (!f) return;
    apri(figure().indexOf(f), f);
  });
  scheda.addEventListener('keydown', function (e) {
    var f = e.target.closest && e.target.closest('[data-gal-apri]');
    if (!f || (e.key !== 'Enter' && e.key !== ' ')) return;
    e.preventDefault();
    apri(figure().indexOf(f), f);
  });

  /* ---------- telefono: frecce sulla striscia ---------- */
  (function () {
    var striscia = scheda.querySelector('[data-pr-foto]');
    var testa = scheda.querySelector('.pr__testa');
    if (!striscia || !testa || figure().length < 2) return;
    var frecce = document.createElement('div');
    frecce.className = 'pr-gal__frecce';
    frecce.innerHTML =
      '<button type="button" class="pr-gal__freccia" data-gal-prima aria-label="Foto precedente">' + ICONA.prima + '</button>' +
      '<button type="button" class="pr-gal__freccia" data-gal-dopo aria-label="Foto successiva">' + ICONA.dopo + '</button>';
    testa.appendChild(frecce);
    var prima = frecce.querySelector('[data-gal-prima]'), dopo = frecce.querySelector('[data-gal-dopo]');
    /* la foto che sta al centro adesso */
    function qui() {
      var centro = striscia.scrollLeft + striscia.clientWidth / 2, meglio = 0, dist = Infinity;
      figure().forEach(function (f, i) {
        var d = Math.abs(f.offsetLeft + f.offsetWidth / 2 - centro);
        if (d < dist) { dist = d; meglio = i; }
      });
      return meglio;
    }
    function posa() { frecce.style.top = (striscia.offsetTop + striscia.offsetHeight / 2) + 'px'; }
    function stato() {
      var fine = striscia.scrollWidth - striscia.clientWidth - 4;
      prima.disabled = striscia.scrollLeft <= 4;
      dopo.disabled = striscia.scrollLeft >= fine;
    }
    /* si va su una foto precisa (scrollTo), non «di tanto» (scrollBy): con lo
       scatto della striscia lo spostamento relativo a volte non partiva */
    function vai(verso) {
      var lista = figure();
      var f = lista[Math.max(0, Math.min(lista.length - 1, qui() + verso))];
      if (!f) return;
      var meta = Math.max(0, Math.min(striscia.scrollWidth - striscia.clientWidth, f.offsetLeft - (striscia.clientWidth - f.offsetWidth) / 2));
      if (pigro) { striscia.scrollLeft = meta; return; }
      /* la corsa la facciamo noi (320 ms, uscita morbida): lo «smooth» del
         browser dentro una striscia con lo scatto a volte non partiva */
      var da = striscia.scrollLeft, t0 = null;
      striscia.style.scrollSnapType = 'none';
      window.cancelAnimationFrame(striscia.__corsa);
      function passo(t) {
        if (t0 === null) t0 = t;
        var k = Math.min(1, (t - t0) / 320), e = 1 - Math.pow(1 - k, 3);
        striscia.scrollLeft = da + (meta - da) * e;
        if (k < 1) { striscia.__corsa = window.requestAnimationFrame(passo); }
        else { striscia.style.scrollSnapType = ''; stato(); }
      }
      striscia.__corsa = window.requestAnimationFrame(passo);
    }
    prima.addEventListener('click', function () { vai(-1); });
    dopo.addEventListener('click', function () { vai(1); });
    striscia.addEventListener('scroll', stato, { passive: true });
    window.addEventListener('resize', function () { posa(); stato(); }, { passive: true });
    window.addEventListener('load', function () { posa(); stato(); });
    posa(); stato();
  })();
})();
